document.addEventListener('DOMContentLoaded', function(e) {
    let sliders = document.querySelectorAll('.custom-slider');

    sliders.forEach(slider => {
        let prev = slider.querySelector('.navigation .left');
        let next = slider.querySelector('.navigation .right');

        prev.addEventListener('click', function(e) {
            prevSlide();
        })

        next.addEventListener('click', function(e) {
            nextSlide();
        })

        function prevSlide() {
            let total = parseInt(slider.dataset.total);
            let currSlide = parseInt(slider.dataset.slide);
            let target = (currSlide <= 1) ? total : currSlide - 1;
            slider.dataset.slide = target;
        }

        function nextSlide() {
            let total = parseInt(slider.dataset.total);
            let currSlide = parseInt(slider.dataset.slide);
            let target = (currSlide >= total) ? 1 : currSlide + 1;
            slider.dataset.slide = target;
        }
    })
})

import './main-search';